import { render } from "./MonthCalendar.vue?vue&type=template&id=96115a6c"
import script from "./MonthCalendar.vue?vue&type=script&lang=js"
export * from "./MonthCalendar.vue?vue&type=script&lang=js"

import "./MonthCalendar.vue?vue&type=style&index=0&id=96115a6c&lang=css"

import exportComponent from "/deploy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__